/**
 * Window event names the auth layer raises and AuthContext listens for. In
 * their own module (not `services/api.ts`) so the many suites that mock the
 * API client wholesale do not have to know about them.
 */

/** B-596: a `403 WRONG_ACTIVE_ROLE` came back — detail: `{ activeRole }`. */
export const ACTIVE_ROLE_MISMATCH_EVENT = 'auth:active-role-mismatch';
